import { createAction, props } from '@ngrx/store';
import { IPusher, TNativeIOSVideoActivity, TError } from '@amwager/util-ts';



/**
 * State
 */
export const initState = createAction(
  '[Common] Init State',
  props<{ sourceInitiator: string }>()
);
export const clearState = createAction(
  '[Common] Clear State',
  props<{ sourceInitiator: string }>()
);

export const loadCommonSuccess = createAction(
  '[Common] Load Common State Success',
);
export const loadCommonFailure = createAction(
  '[Common] Load Common State Failure',
  props<{ error: TError }>()
);



/**
 * Properties
 */
export const setIsComponentView = createAction(
  '[Common] Set url request to view component',
  props<{ isComponentView: boolean }>()
);

export const reProfile = createAction(
  '[Common] Reprofile for Threatmatrix'
);

export const setTmsId = createAction(
  '[Common] Set tms id, Threatmatrix',
  props<{ tmsId: string; }>()
);

export const setIsShowNavigation = createAction(
  '[Common] Set navigation status if hide or show',
  props<{ isShowNavigation: boolean; }>()
);

export const setIsShowFooter = createAction(
  '[Common] Set footer status if hide or show',
  props<{ isShowFooter: boolean; }>()
);

export const setIsAuthenticated = createAction(
  '[Common] Set if authenticated or not',
  props<{
    sourceInitiator: string,
    isAuthenticated: boolean
  }>()
);

export const setErrorAPI = createAction(
  '[Common] Set error from API',
  props<{
    isErrorAPI: {
      from?: boolean,
      message: string,
      statusCode: number,
      hasError: boolean
    }
  }>()
);

export const qaTesting = createAction(
  '[Common] Set QA testing',
  props<{
    qaTesting: {
      showStatusCodeInToastMessage?: boolean,
      showMessageCodeInToastMessage?: boolean,
      showMessageInToastMessage?: boolean,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      wagerCustom?: any
    }
  }>()
);

export const setToDismissModal = createAction(
  '[Common] Set to dismiss modal',
  props<{ isDismiss: boolean; }>()
);



/**
 * Log
 */
export const logModule = createAction(
  '[Common] Log mounted Module',
  props<{ moduleName: string }>()
);

export const logComponent = createAction(
  '[Common] Log mounted Component',
  props<{ componentName: string }>()
);

export const log = createAction(
  '[Common] Log',
  props<{ message: string }>()
);

export const logSuccess = createAction(
  '[Common] Log Success',
  props<{ message: string }>()
);

export const logError = createAction(
  '[Common] Log Error',
  props<{
    message: TError,
    typeError?: string
 }>()
);


/**
 * Pusher Command
 */
export const pusherData = createAction(
  '[Common] Pusher Command',
  props<{
    sourceInitiator: string,
    command: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: IPusher
  }>()
);


/**
 * Back navigation
 */
export const backNavigation = createAction(
  '[Common] Back Navigation',
  props<{
    sourceInitiator: string,
  }>()
);

/**
 * Online connection
 */
export const isConnectedInternet = createAction(
  '[Common] Internet Connection',
  props<{
    sourceInitiator: string,
    isConnected: boolean
  }>()
);

/**
 * Native IOS Video Activity
 */
export const nativeIOSVideoActivity = createAction(
  '[Common] Native IOS Video Activity',
  props<{
    sourceInitiator: string,
    nativeIOSVideoActivity: TNativeIOSVideoActivity
  }>()
);
